import { render, staticRenderFns } from "./PayrollReport.vue?vue&type=template&id=0f8c4042"
import script from "./PayrollReport.vue?vue&type=script&lang=ts"
export * from "./PayrollReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports